class ProductPageUIUpdater {
  static updatePriceInButtons(element, price, compareAtPrice, variant) {
    //@ts-ignore
    let productId = element.closest('[data-product-id]')?.dataset.productId;
    let currentVariantId = parseInt(variant.id);
    let variantsMetafieldsJsonElement = document.getElementById(`VariantsMetafieldsJson-${productId}`);
    let variantsMetafieldsJson = null;
    if (variantsMetafieldsJsonElement) variantsMetafieldsJson = JSON.parse(variantsMetafieldsJsonElement.textContent);
    let currentVariantMetafieldsJson = variantsMetafieldsJson?.find((variant) => variant.id === currentVariantId);

    let addToCartText = window.theme.strings.addToCart; // Assuming window.theme.strings.addToCart is defined
    let addToCartFinalText = '';

    let isPreorder = false;
    if ((currentVariantMetafieldsJson && currentVariantMetafieldsJson.preorder === true) || element.dataset.preOrder === 'true') {
      isPreorder = true;
    }
    if (isPreorder) {
      addToCartText = theme.strings.preOrder; // Assuming window.theme.strings.preOrder is defined
    }

    if (variant.available) {
      element.removeAttribute('disabled');
      if (window.matchMedia('(min-width: 0px)').matches) {
        addToCartFinalText =
          price === compareAtPrice || compareAtPrice === null || compareAtPrice === 0
            ? `${addToCartText} • ${stringifyPrice(price)}`
            : `${addToCartText} • ${stringifyPrice(price)} <s>${stringifyPrice(compareAtPrice)}</s>`;
      } else {
        addToCartFinalText = addToCartText;
      }
    } else {
      //@ts-ignore
      addToCartFinalText = window.theme.strings.soldOut; // Assuming window.theme.strings.soldOut is defined
    }

    element.innerHTML = addToCartFinalText;
  }
  static updateKlaviyoButton(availability) {
    const klaviyoButton = document.querySelector('.klaviyo-bis-trigger');
    if (!klaviyoButton) return;
    if (availability === true) {
      klaviyoButton.style.display = 'none';
    } else {
      klaviyoButton.style.display = 'block';
    }
  }
  static updatePricesTopProductPage(productPrice, productComparePrice, price, compareAtPrice) {
    productPrice.innerHTML = stringifyPrice(price);

    if (price === compareAtPrice || compareAtPrice === null || compareAtPrice === 0) {
      productComparePrice.classList.add('hide');
    } else {
      productComparePrice.innerHTML = stringifyPrice(compareAtPrice);
      productComparePrice.classList.remove('hide');
    }
  }

  static updatePricesInBuyXgetY(price, compareAtPrice, priceElement, compareAtPriceElement) {
    //@ts-ignore
    const productPriceParentNode = priceElement.closest('.bxgy__product-prices-and-economy');
    const productEconomy = productPriceParentNode.querySelector('.bxgy__product-economy');
    const productEconomyValue = productPriceParentNode.querySelector('.bxgy__product-economy-value');

    if (priceElement && compareAtPriceElement) {
      priceElement.innerHTML = stringifyPrice(price);
      compareAtPriceElement.innerHTML = stringifyPrice(compareAtPrice);
      productEconomyValue.innerHTML = stringifyPrice(compareAtPrice - price);
    }

    const buttonAddToCart = document.querySelector('[data-add-to-cart]');
    const buttonAddToCartText = buttonAddToCart.dataset.addToCartText;

    if (compareAtPrice > price) {
      if (buttonAddToCart && buttonAddToCartText) productEconomy.classList.remove('hide');
      buttonAddToCart.innerHTML = `${buttonAddToCartText} • ${stringifyPrice(price)} <s>${stringifyPrice(compareAtPrice)}</s>`;
    } else {
      if (compareAtPrice === null || compareAtPrice === price || compareAtPrice === 0) {
        compareAtPriceElement?.classList.add('hide');
        productEconomy.classList.add('hide');

        if (buttonAddToCart && buttonAddToCartText) buttonAddToCart.innerHTML = `${buttonAddToCartText} • ${stringifyPrice(price)}`;
      } else {
        compareAtPriceElement?.classList.remove('hide');
        productEconomy.classList.remove('hide');

        if (buttonAddToCart && buttonAddToCartText) buttonAddToCart.innerHTML = `${buttonAddToCartText} • ${stringifyPrice(price)}`;
      }
    }
  }

  static updateDiscountSticker(price, compareAtPrice, discountPercentage) {
    const reduction_type = document.querySelector('[data-reduction-type]').dataset.reductionType;
    const reduction_stickers = document.querySelectorAll('[data-reduction-type]');
    const price_economy_labels = document.querySelectorAll('[data-price-economy]');

    function switchReductionTypeCase(element, reduction_type) {
      switch (reduction_type) {
        case 'percent':
          element.innerHTML = stringifyDiscountedPercentage(discountPercentage);
          discountPercentage === 0 ? element.classList.add('hide') : element.classList.remove('hide');
          break;
        default:
          let amount = price;
          compareAtPrice ? (amount = compareAtPrice - price) : (amount = price);
          element.innerHTML = stringifyPrice(amount);
          break;
      }
    }

    function updateEconomyLabel(element) {
      const economy_value = element.querySelector('[data-economy-amount]');
      let amount = price;
      compareAtPrice ? (amount = compareAtPrice - price) : (amount = price);
      if (economy_value !== null) economy_value.innerHTML = stringifyPrice(amount);
    }

    if (isReduction(price, compareAtPrice) === true) {
      reduction_stickers.forEach((element) => element.classList.remove('hide'));
      price_economy_labels.forEach((element) => element.classList.remove('hide'));

      if (reduction_stickers.length > 0) {
        reduction_stickers.forEach((element) => {
          switchReductionTypeCase(element, element.dataset.reductionType);
        });
      }
      
      if (price_economy_labels.length > 0) {
        price_economy_labels.forEach((element) => {
          updateEconomyLabel(element);
        });
      }
    } else {
      reduction_stickers.forEach((element) => {
        element.classList.add('hide');
      });
      
      price_economy_labels.forEach((element) => {
        element.classList.add('hide');
      });
    }
  }
}
